import * as types from './types';
import { loading, error, success } from 'State/actions';
import { ASSIGN_ORDER_PREFERENCE_FORM_NAME } from 'Common/FormEnum';
import { change } from 'redux-form';

export const getSiteGroupWithSitesAndWarehouse = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(
      loading(types.FETCH_SITEGROUP_WITH_SITES_AND_WAREHOUSE_LOADING, true)
    );

    try {
      const response = await MPWWebApi.getGeneric(
        'SiteGroup/GetSiteGroupWithSitesAndWarehouse'
      );
      dispatch(
        success(
          types.SITEGROUP_WITH_SITES_AND_WAREHOUSE_DATA,
          response.data.Data ? response.data.Data : []
        )
      );
    } catch (err) {
      dispatch(
        error(types.FETCH_SITEGROUP_WITH_SITES_AND_WAREHOUSE_LOADING_ERROR, err)
      );
    } finally {
      dispatch(
        loading(types.FETCH_SITEGROUP_WITH_SITES_AND_WAREHOUSE_LOADING, false)
      );
    }
  };
};

export const getWarehouses = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCH_SITE_GROUP_WAREHOUSE_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric('SiteGroup/GetWarehouses');
      dispatch(
        success(
          types.SITE_GROUP_WAREHOUSE_DATA,
          response.data.Data ? response.data.Data : []
        )
      );
    } catch (err) {
      dispatch(error(types.FETCH_SITE_GROUP_WAREHOUSE_LOADING_ERROR, err));
    } finally {
      dispatch(loading(types.FETCH_SITE_GROUP_WAREHOUSE_LOADING, false));
    }
  };
};

export const clearErrorMsgs = () => {
  return {
    type: types.CLEAR_ERROR_MESSAGES,
  };
};
export const saveSiteGroupWarehouse = payload => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SUBMITTING_ORDER_PREFERENCE_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'SiteGroup/SaveSiteGroupWarehouse',
        payload
      );
      dispatch(success(types.SUBMITTED_ORDER_PREFERENCE_DATA, response));
    } catch (ex) {
      dispatch(error(types.SUBMITTING_ORDER_PREFERENCE_LOADING_ERROR, ex));
    } finally {
      dispatch(loading(types.SUBMITTING_ORDER_PREFERENCE_LOADING, false));
    }
  };
};
export const saveSiteWarehouse = payload => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SUBMITTING_ORDER_PREFERENCE_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'SiteGroup/SaveSiteWarehouse',
        payload
      );
      dispatch(success(types.SUBMITTED_ORDER_PREFERENCE_DATA, response));
    } catch (ex) {
      dispatch(error(types.SUBMITTING_ORDER_PREFERENCE_LOADING_ERROR, ex));
    } finally {
      dispatch(loading(types.SUBMITTING_ORDER_PREFERENCE_LOADING, false));
    }
  };
};
export const clearSubmitError = () => {
  return {
    type: types.CLEAR_SUBMIT_ERROR,
  };
};
export const changeFormValue = (fieldName, value) => {
  return change(ASSIGN_ORDER_PREFERENCE_FORM_NAME, fieldName, value);
};



// WEBPACK FOOTER //
// ./src/pages/utilities/state/assignorderpreference/actions.js